import { useNavigate } from 'react-router-dom';
import PlusIcon from '@/assets/img/plus-icon.svg';
import Dots from '@/assets/img/dots-3.svg';
import Edit from '@/assets/img/edit-icon.svg';
import { useGetAllLocations } from '@/features/location/api/getLocations';
import Lottie from 'lottie-react';
import { DeleteLocation } from '../components/DeleteLocation';
import Dropdown from 'react-bootstrap/Dropdown';
import noDataAnimation from '@/assets/animation/no_data.json';
import ReactPaginate from 'react-paginate';
import { useEffect, useState } from 'react';
import { Location } from '../types';

export const LocationList = () => {
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(0);
  const perPage = 10;
  const [locationList, setLocationList] = useState<Location[]>();
  const [selectedPage, setSelectedPage] = useState(1);
  const getLocationMutation = useGetAllLocations();

  useEffect(() => {
    fetchLocation();
  }, []);
  const fetchLocation = async () => {
    const res = await getLocationMutation.mutateAsync({
      page: selectedPage,
      perPage: perPage,
    });
    setTotalPages(res.totalPages);
    setLocationList(res.list);
  };
  useEffect(() => {
    fetchLocation();
  }, [selectedPage]);

  const handlePageClick = async (event: any) => {
    setSelectedPage(event.selected + 1);
  };
  return (
    <div>
      <div className="page-title">Locations</div>
      <div className="add-cal-btn">
        <button
          onClick={ () => {
            navigate('/add-location');
          } }
          className="traparant-btn inline-flex items-center float-right-btn"
        >
          <img src={ PlusIcon } className="plus-icon" />
          <span>Add Location</span>
        </button>
      </div>
      <div className="card-table">
        <div className="table-row table-head-row">
          <div className="two-col-outer">
            <div className="table-head width-50">Name</div>
            <div className="table-head width-25">Address</div>
            <div className="table-head width-25">Google Place ID</div>
          </div>
        </div>
        { !locationList || locationList.length < 1 ? (
          <div>
            <div className="h-full w-full flex items-center justify-center">
              <Lottie className="h-40 w-40" animationData={ noDataAnimation } />
            </div>
            <div className="upcoming-sub-title">You have not added locations yet</div>
          </div>
        ) : null }
        { locationList &&
          locationList.map((item, itemIndex) => {
            return (
              <div className="table-row" key={ itemIndex }>
                <div className="two-col-outer">
                  <div className="table-cell width-50">{ item.name }</div>
                  <div className="table-cell width-25">{ item.address }</div>
                  <div className="table-cell width-25">{ item.googlePlaceId }</div>
                </div>

                <Dropdown className="dot-3-btn">
                  <Dropdown.Toggle id="dropdown-basic" className="dots-3-icon">
                    <img src={ Dots } className="dots-icon" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="drop-down-backdrop">
                    <Dropdown.Item
                      onClick={ () => {
                        navigate(`/services/${item.googlePlaceId}`);
                      } }
                      className="menu-btn"
                    >
                      Manage Services
                    </Dropdown.Item>

                    <DeleteLocation
                      location={ item }
                      onDelete={ () => {
                        fetchLocation();
                      } }
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            );
          }) }
        { totalPages > 1 && (
          <div className="pagination-outer">
            <ReactPaginate
              nextLabel="Next"
              onPageChange={ handlePageClick }
              pageRangeDisplayed={ 3 }
              marginPagesDisplayed={ 2 }
              pageCount={ totalPages }
              previousLabel="Previous"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
            />
          </div>
        ) }
      </div>
    </div>
  );
};
